export const color = {
  ESLint: '#4b32c3',
  React: '#61dafb',
  CSS3: '#1572b6',
  Webpack: '#8dd6f9',
  Sass: '#cc6699',
  Rust: '#000000',
  JavaScript: '#f7df1e',
  Git: '#f05032',
  Django: '#092e20',
  Java: '#007396',
  Node: '#339933',
  Vue: '#4fc08d',
  Gatsby: '#663399',
  VisualStudioCode: '#007acc',
  Elasticsearch: '#005571',
  PostgreSQL: '#336791',
  Python: '#3776ab',
  Blender: '#f5792a',
  Go: '#76e1fe',
  Disqus: '#2e9fff',
  Deno: '#000000',
  Jest: '#C21325',
};
